import { render, staticRenderFns } from "./inviteRule.vue?vue&type=template&id=688c68d6&"
import script from "./inviteRule.vue?vue&type=script&lang=js&"
export * from "./inviteRule.vue?vue&type=script&lang=js&"
import style0 from "./inviteRule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports